import { observer } from 'mobx-react';
import { theme } from 'antd';

import GetConnectivityIconAndStatus from '@/comp/MapBuilder/nodes/compressor/GetConnectivityIconAndStatus/GetConnectivityIconAndStatus';
import { isSelectedNodeOnMap } from '@/comp/MapBuilder/utils/utils';
import { useStores } from '@/hooks/use-stores';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';
import { compressorTypes, DeviceType } from '@/constants/deviceTypeEnum';
import { Container } from './ActivityIndication.style';
import { getIconSize } from './ActivityIndication.utils';

const { useToken } = theme;

const deviceTypesWithActivityIndication = [
  ...compressorTypes,
  DeviceType.Booster,
  DeviceType.DesiccantAirDryer,
  DeviceType.OpenCloseValve,
  DeviceType.ProportionalValve,
  DeviceType.SpillValve,
];

type Props = {
  entity: Entity;
  size?: 'small' | 'large';
  direction?: 'horizontal' | 'vertical';
};

const ActivityIndication = observer(({ entity, size = 'large', direction = 'vertical' }: Props) => {
  const { token } = useToken();
  const { mapBuilderStore } = useStores();
  const { controlMode, connectivity, activity, extendedActivity, deviceType } = entity;
  const isSelected = isSelectedNodeOnMap(entity.deviceId, mapBuilderStore.selectedDevice?.deviceId, false);
  const connectivityIconAndStatus = GetConnectivityIconAndStatus({
    connectivity,
    activity,
    extendedActivity,
    controlMode,
    isSelectedOnMap: isSelected,
    size: getIconSize(size, token),
    shouldHideTooltip: true,
  });

  return (
    <Container className={`activity-indication activity-indication-${direction} activity-indication-${size}`}>
      {deviceTypesWithActivityIndication.includes(deviceType as DeviceType) && (
        <>
          {connectivityIconAndStatus.icon}
          <span className="activity-label">{connectivityIconAndStatus.status}</span>
        </>
      )}
    </Container>
  );
});

export default ActivityIndication;
